<nav aria-label="breadcrumb" *ngIf="breadcrumbs?.length">
  <ol class="breadcrumb">
    <li>
      <span>
        <a href="/home"> {{ title | translate }} </a>
        <span>></span>
        <ng-container *ngFor="let breadcrumb of breadcrumbs; last as isLast">
          <ng-container *ngIf="isLast">
            <span class="capt"> {{ breadcrumb.label | translate }} </span>
          </ng-container>
          <ng-container *ngIf="!isLast && breadcrumb.url !== ''">
            <a href="{{ breadcrumb.url }}" class="capt"> {{ breadcrumb.label | translate }} </a>
          </ng-container>
          <ng-container *ngIf="!isLast && breadcrumb.url == ''">
            <span class="capt"> {{ breadcrumb.label | translate }} </span>
          </ng-container>
          <span *ngIf="!isLast">></span>
        </ng-container>
      </span>
    </li>
  </ol>
</nav>
